import TweenMax from 'gsap'
import Emitter from 'core/Emitter'
import * as PIXI from 'pixi.js'
import Detector from 'utils/Detector'
import 'styles/components/loader.styl'
let instance = null

export default class LoaderManager {
  constructor (opts) {
    if (!instance) {
      instance = this
      this.loader = new PIXI.loaders.Loader()
      this.resources = {}
      this.files = []

      this.isShowed = true

      this.dom = {
        el: document.querySelector('.loader'),
        background: document.querySelector('.loader .loader__background'),
        percent: document.querySelector('.loader .loader__percent'),
        logo: document.querySelector('.loader .loader__logo')
      }

      this.bindAll()
      this.addListeners()
    }
    return instance
  }

  addListeners () {
    Emitter.on('LOADER::SHOW', this.showLoader)
    Emitter.on('LOADER::HIDE', this.hideLoader)
    Emitter.on('LOADER::UPDATE_PERCENT', this.updatePercent)
    Emitter.on('LOADER::ADD_FILES', this.addFiles)

    this.loader.onProgress.add(({progress}) => {
      this.updatePercent(progress)
    })
  }

  removeListeners () {
  }

  bindAll () {
    ['showLoader', 'hideLoader', 'updatePercent', 'addFiles'].forEach((fn) => (this[fn] = this[fn].bind(this)))
  }

  addFiles (files) {
    files.forEach((file, i) => {
      this.files.push(file)
    })
  }

  loadAll (cb) {
    this.showLoader()

    this.files.forEach((file, i) => {
      this.loader.add(file)
    })

    this.loader.load((loader, resources) => {
      this.resources = resources
      this.hideLoader(cb)
    })
  }

  updatePercent (value) {
    this.dom.percent.innerHTML = `${Math.round(value)}%`
  }

  showLoader () {
    if (this.isShowed) return

    this.isShowed = true
    this.dom.el.style.display = ''
  }

  resetCSS () {
    this.dom.background.style.transformOrigin = ''
    this.dom.background.style.transform = ''
    this.dom.percent.style.transform = this.dom.percent.style.visibility = this.dom.percent.style.opacity = ''
    this.dom.logo.style.transform = this.dom.logo.style.visibility = this.dom.logo.style.opacity = ''
  }

  hideLoader (cb) {
    if (!this.isShowed) return

    this.isShowed = false
    let tl = new TimelineMax({
      onComplete: () => {
        this.dom.el.style.display = 'none'
        this.resetCSS()
        if (cb) {
          cb()
        }
      }
    })
    tl
    .to(this.dom.percent, 0.6, {
      y: 50,
      autoAlpha: 0,
      ease: Quint.easeOut,
      onComplete: () => {
      }
    }, 'start')
    .to(this.dom.logo, 0.6, {
      autoAlpha: 0,
      ease: Quint.easeOut
    }, 'start+=0.1')
    .to([this.dom.background], 0.8, {
      autoAlpha: 0,
      ease: Cubic.easeOut
    }, 'start+=0.4')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/LoaderManager.js
 **/